<div class="view-wrapper" @viewLoader>
  <div class="view-content">
    <div class="view-section">
      @if (job(); as currentJob) {
        <h4>{{ currentJob.jobTitle }}</h4>
        <p class="text-muted company">{{ currentJob.companyName }}</p>
        <ct-lib-inline-info>
          <p>{{ 'jobboard.platform.apply-with-profile.manual-intro' | transloco }}</p>
        </ct-lib-inline-info>
        <form class="manual-form" [formGroup]="form" (ngSubmit)="submit()">
          <div class="row">
            <div
              class="col-12 col-md-6 form-group form-floating"
              [class.invalid]="form.controls['firstName'].invalid && submitAttempt()"
            >
              <input
                type="text"
                class="form-control"
                formControlName="firstName"
                id="manualFirstName"
                [placeholder]="'jobboard.platform.profile.sections.contact.first-name' | transloco"
              />
              <label for="manualFirstName">{{
                'jobboard.platform.profile.sections.contact.first-name' | transloco
              }}</label>
            </div>
            <div
              class="col-12 col-md-6 form-group form-floating"
              [class.invalid]="form.controls['lastName'].invalid && submitAttempt()"
            >
              <input
                type="text"
                class="form-control"
                formControlName="lastName"
                id="manualLastName"
                [placeholder]="'jobboard.platform.profile.sections.contact.last-name' | transloco"
              />
              <label for="manualLastName">{{
                'jobboard.platform.profile.sections.contact.last-name' | transloco
              }}</label>
            </div>
            <div
              class="col-12 col-md-6 form-group form-floating"
              [class.invalid]="form.controls['email'].invalid && submitAttempt()"
            >
              <input
                type="email"
                class="form-control"
                formControlName="email"
                id="manualEmail"
                [placeholder]="'jobboard.platform.profile.sections.contact.email' | transloco"
              />
              <label for="manualEmail">{{
                'jobboard.platform.profile.sections.contact.email' | transloco
              }}</label>
            </div>
            <div class="col-12 col-md-6 form-group form-floating">
              <input
                type="tel"
                class="form-control"
                formControlName="phone"
                id="manualPhone"
                [placeholder]="'jobboard.platform.profile.sections.contact.phone' | transloco"
              />
              <label for="manualPhone">{{
                'jobboard.platform.profile.sections.contact.phone' | transloco
              }}</label>
            </div>
          </div>
          <ct-lib-file-input
            [control]="cvControl()"
            [multiple]="false"
            [accept]="fileTypes"
            [showAcceptLabel]="false"
            [submitAttempt]="submitAttempt() && form.controls['cv'].invalid"
            [label]="'jobboard.platform.jobs.applications.complete-fields.cv' | transloco"
          ></ct-lib-file-input>
          <div
            class="form-group terms"
            [class.invalid]="form.controls['privacyAccepted'].invalid && submitAttempt()"
          >
            <input type="checkbox" id="manualPrivacy" formControlName="privacyAccepted" />
            <label for="manualPrivacy">
              {{ 'jobboard.views.apply.sections.finish.agb-1' | transloco }}
              <a href="https://catch.hr/tos-applicants" target="_blank" rel="noopener noreferrer">{{
                'jobboard.views.apply.sections.finish.agb-2' | transloco
              }}</a>
              {{ 'jobboard.views.apply.sections.finish.agb-3' | transloco }}
            </label>
          </div>
          <div class="footer-actions">
            <app-button variant="white-grey" htmlType="button" [routerLink]="['/jobs', 'recommendations', currentJob.id]">
              {{ 'jobboard.platform.apply-with-profile.manual-back' | transloco }}
            </app-button>
            <app-button variant="primary" htmlType="submit">
              {{ 'jobboard.platform.apply-with-profile.submit' | transloco }}
            </app-button>
          </div>
        </form>
      } @else {
        <ct-lib-empty-placeholder
          [icon]="icons.search"
          [title]="'jobboard.platform.recommendations.job-detail.missing-title' | transloco"
          [text]="'jobboard.platform.recommendations.job-detail.missing-text' | transloco"
        />
      }
    </div>
  </div>
</div>
